<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                </form>
                </div>
        </nav>
        <div class="table-responsive text-center">
            <table class="table table-bordered">
               <thead>
               <tr>
                   <th>รหัสลูกค้า</th>
                   <th>ชื่อลูกค้า</th>
                   <th>ยอดขาย</th>
                   <th>พิมพ์</th>
               </tr>
               </thead>
                <tbody>
                <tr v-for="data in special_customer_table">
                    <td>
                        {{data.customer_id}}
                    </td>
                    <td>
                        {{data.customer_name}}
                    </td>
                    <td>
                        {{data.total | currency}}
                    </td>
                    <td>
                        <button type="button" class="btn btn-default next" @click="showSpecialCustomer(data.id)">
                            <icon name="edit"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--<pre class="alert-danger">{{special_customer_table}}</pre>-->
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "special-customer",
        created(){
            this.$store.dispatch("SpecialCustomer/setCustomerReport");
        },
        data(){
          return{
              domain : ""
          }
        },
        computed:{
            ...mapState({
                special_customer_table : state=>{
                    return state.SpecialCustomer.customer_report_table;
                },
            })
        },
        methods:{
            showSpecialCustomer(customer_id){
                this.$store.dispatch("SpecialCustomer/showCustomerSpecial", {
                    page : 1,
                    data : {
                        customer_id,
                        start_date : '',
                        end_date : '',
                        product_type_id : '',
                    }
                }).then(()=>{
                    this.$router.push({
                        name : "special-customer-form",
                        params : {customer_id}
                    })
                });
            },
        }
    }
</script>

<style scoped>

</style>
